/**
 * Utility to preserve URL parameters when navigating between pages
 */
export const preserveUrlParams = (targetPath: string, paramsToPreserve?: string[]): string => {
  const currentParams = new URLSearchParams(window.location.search)
  const newUrl = new URL(targetPath, window.location.origin)

  if (paramsToPreserve) {
    // If specific parameters are provided, only preserve those
    paramsToPreserve.forEach((param) => {
      const value = currentParams.get(param)
      if (value) {
        newUrl.searchParams.set(param, value)
      }
    })
  } else {
    // By default, preserve ALL URL parameters
    currentParams.forEach((value, key) => {
      newUrl.searchParams.set(key, value)
    })
  }

  return newUrl.pathname + newUrl.search
}

/**
 * Get the current URL parameters as an object
 */
export const getCurrentUrlParams = (): Record<string, string> => {
  const params = new URLSearchParams(window.location.search)
  const result: Record<string, string> = {}

  params.forEach((value, key) => {
    result[key] = value
  })

  return result
}
